import { render, staticRenderFns } from "./SummaryMatchContainer.vue?vue&type=template&id=e972b4f4&scoped=true&"
import script from "./SummaryMatchContainer.vue?vue&type=script&lang=js&"
export * from "./SummaryMatchContainer.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMatchContainer.vue?vue&type=style&index=0&id=e972b4f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e972b4f4",
  null
  
)

export default component.exports